
import { Component, Vue } from "vue-property-decorator";
import { PaymentRequest } from "@/models/paymentRequest";
import { TRANSFER_TYPE } from "@/constant";
import VueNumeric from "vue-numeric";
import Axios from "axios";
import { API_STORE } from "../../config";
import { getAPIAuthorizedHeader } from "../../services/common";
import DatePicker from "vuejs-datepicker";
import NewPageLoader from "@/views/NewPageLoader.vue";
import Swal from "sweetalert2";

@Component({ components: { VueNumeric, DatePicker, NewPageLoader } })
export default class PaymentRequestComponent extends Vue {
  public paymenRequest = new PaymentRequest();
  public transferType = TRANSFER_TYPE;
  public imageFile = null;
  public imageSrc = null;
  public bankList = [];
  public disableSubmitbutton = false;
  public newPageLoader = true;
  public datedisablefrom: any = { from: new Date()};
  public selectedAccountNumber = null;
  public selectedCharge = null;

  public fileChangeEvent(event) {
    this.imageSrc = URL.createObjectURL(event.target.files[0]);
    this.imageFile = event.target.files[0];
  }

  public async validateAndRequest() {
    let valid = await this.$validator.validateAll();
    if (valid) {
      this.disableSubmitbutton = true;
      this.newPageLoader = true;
      let formData = new FormData();
      if (this.imageFile) {
        formData.append("file", this.imageFile);
      }
      this.paymenRequest["isClient"] = this.$isClient;
      this.paymenRequest["requestedBy"] = this.$userId;
      this.paymenRequest["requestedTo"] = this.$client.adminId; //  this.$isClient? this.$client.adminId : this.$client.clientUserId;
      this.paymenRequest["subdomain"] = this.$client.subdomain;
      formData.append("jsonData", JSON.stringify(this.paymenRequest));

      let response = await Axios.post(
        API_STORE.PORTAL + "paymentRequest",
        formData,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.newPageLoader = false;
      this.disableSubmitbutton = false;
      if (response && response.data) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: true,
        });
        this.$router.push("/portal");
      }
    }
  }
  public async getBankList() {
    let response = await Axios.get(API_STORE.ADMIN + "getBankList", {
      params: {
        active: true,
      },
      headers: getAPIAuthorizedHeader(),
    });
    if (response && response.data) this.bankList = response.data.bankList;
  }


  public async bankSelected(bank){
    console.log(bank.target.value)
    let selectedBank = this.bankList.filter(item => item._id ==bank.target.value)
    this.selectedAccountNumber = selectedBank[0].accountNumber;
    this.selectedCharge = selectedBank[0].charge ? selectedBank[0].charge : 0
  }

  mounted() {
    this.getBankList();
    this.newPageLoader = false;
  }
}
